module.exports = __webpack_public_path__ + "img/battery.54b7e41a.svg";